import React, { useEffect, useState, useMemo } from "react";
import "./required.css";
import { useStore } from "../../store/store";
import { WrapperOver240, WrapperUnder240 } from "./Wrappers";
import { styled } from "@mui/material/styles";

const StyledSpan = styled("span")({
  color: "#4b4b4b",
});

function RequiredDisplayPivot() {
  const material = useStore((state) => state.quote.material);
  const woodSpecies = useStore((state) => state.quote.woodAbbrev);
  const unitSize = useStore((state) => state.quote.unitSize);
  const unitSizeFraction = useStore((state) => state.quote.unitSizeFraction);
  const height = useStore((state) => state.quote.height);
  const heightFraction = useStore((state) => state.quote.heightFraction);
  const exactConfig = useStore((state) => state.quote.exactConfig);
  const pivotHardware = useStore((state) => state.quote.pivotHardware);
  const pivotAction = useStore((state) => state.quote.pivotAction);

  const [scrollPosition, setScrollPosition] = useState<number | null>(null);

  const listenScrollEvent = () => setScrollPosition(window.scrollY);

  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);

    return () => window.removeEventListener("scroll", listenScrollEvent);
  });

  const header = useMemo(() => {
    return (
      <div className="header">
        <p>
          {material ? (
            <>
              <StyledSpan>Material - </StyledSpan>
              {material}
            </>
          ) : (
            "Material"
          )}
        </p>
        <p>
          {woodSpecies ? (
            <>
              <StyledSpan>Wood - </StyledSpan>
              {woodSpecies}
            </>
          ) : (
            "Wood Species"
          )}
        </p>
        <p>
          {unitSize ? (
            <>
              <StyledSpan>Width - </StyledSpan> {unitSize} {unitSizeFraction}{" "}
              inches
            </>
          ) : (
            "Width"
          )}
        </p>
        <p>
          {height ? (
            <>
              <StyledSpan>Height - </StyledSpan> {height} {heightFraction}{" "}
              inches
            </>
          ) : (
            "Height"
          )}
        </p>
        <p>
          {exactConfig ? (
            <>
              <StyledSpan>Configuration -</StyledSpan> {exactConfig}
            </>
          ) : (
            "Configuration"
          )}
        </p>
        <p>
          {pivotHardware && pivotAction ? (
            <>
              <StyledSpan>Hardware -</StyledSpan> {pivotHardware} {pivotAction}
            </>
          ) : (
            "Hardware"
          )}
        </p>
      </div>
    );
  }, [
    material,
    woodSpecies,
    unitSize,
    unitSizeFraction,
    height,
    heightFraction,
    exactConfig,
    pivotHardware,
    pivotAction,
  ]);

  return (
    <>
      {scrollPosition && scrollPosition >= 240 ? (
        <WrapperOver240>{header}</WrapperOver240>
      ) : (
        <WrapperUnder240>{header}</WrapperUnder240>
      )}
    </>
  );
}

export default RequiredDisplayPivot;
